const sidebar = {
  carbody_catalogue_sync: 'Sync catalogue',
  carbody_catalogue_order: 'Order export catalogue',
  stock_bot: 'Stock Bot',
  stock_bot_panoramica: 'Overview',
  stock_bot_dettagli: 'Details',
  teccom: 'TecCom',
  teccom_dispatch_advices_index: 'Dispatch advices (DDT)',
  teccom_order_confirmations_index: 'Order confirmations',
}

export default sidebar
